module.exports = __webpack_public_path__ + "images/doc-md-list-c74e7690e8dcabac50bb8f88c025840e.png";